import type { ReactNode } from "react";

export function Section({
  eyebrow,
  title,
  titleAs,
  intro,
  children,
  className = "",
}: {
  eyebrow?: string;
  title?: string;
  titleAs?: "h1" | "h2";
  intro?: string;
  children?: ReactNode;
  className?: string;
}) {
  const TitleTag = titleAs === "h1" ? "h1" : "h2";
  return (
    <section className={`mx-auto max-w-6xl px-6 py-20 md:py-24 ${className}`}>
      {(eyebrow || title || intro) && (
        <div className="max-w-3xl mb-12 md:mb-16">
          {eyebrow && <p className="eyebrow mb-4">{eyebrow}</p>}
          {title && (
            <TitleTag className="font-serif text-3xl md:text-4xl leading-tight text-foreground">
              {title}
            </TitleTag>
          )}
          {intro && (
            <p className="mt-5 text-lg text-muted-foreground leading-relaxed max-w-2xl">
              {intro}
            </p>
          )}
        </div>
      )}
      {children}
    </section>
  );
}
